import React, {useState} from 'react';
import Grid from "@material-ui/core/Grid";
import {StyledInput} from "../../form/input";
import {StyledButton} from "../../ui-base/button";
import ClearIcon from "@mui/icons-material/Clear";
import Menu from "@material-ui/core/Menu";
import {StyledRadioButton} from "../../form/radio";
import styled from "styled-components";
import {useTranslation} from "react-i18next";

export const SearchBooks: React.FC<Props> = ({loadManuscripts, showSort = true}) => {
    const [sortValue, setSortValue] = useState<'asc'|'desc'>('desc');
    const [sortFieldValue, setSortFieldValue] = useState<'submitted_date'|'matching'>('submitted_date');
    const [searchValue, setSearchValue] = useState('');
    const [sortAnchorEl, setSortAnchorEl] = React.useState(null);
    const { t } = useTranslation(['publisher', 'common']);

    const searchChanged = (event) => {
        setSearchValue(event.target.value);
    }

    const searchSubmitted = () => {
        loadManuscripts(sortFieldValue, sortValue, searchValue);
    }

    const clearSearch = () => {
        setSearchValue('');
        loadManuscripts(sortFieldValue, sortValue, '');
    }

    const handleSortClick = (event) => {
        setSortAnchorEl(event.currentTarget);
    };

    const handleSortClose = (event) => {
        setSortAnchorEl(null);
    };

    const sortFieldChanged = (event) => {
        setSortFieldValue(event.target.value);
        loadManuscripts(event.target.value, sortValue, searchValue);
    }

    const sortChanged = (event) => {
        setSortValue(event.target.value);
        loadManuscripts(sortFieldValue, event.target.value, searchValue);
    }

    return (
        <Grid container direction={"row"} alignItems={"center"} spacing={1}>
            <Grid item xs>
                <StyledInput
                    id="search-field"
                    label=""
                    placeholder={t('searchBooksComponent.searchField')}
                    onChange={searchChanged}
                    value={searchValue}
                />
            </Grid>

            <Grid item>
                <StyledButton type={"button"} color={'transparent'} onClick={clearSearch}>
                    <ClearIcon />
                </StyledButton>
            </Grid>

            <Grid item>
                <StyledButton type={'button'} color={'violet'} onClick={searchSubmitted}>
                    {t('searchBooksComponent.searchButton')}
                </StyledButton>
            </Grid>

            {showSort &&
            <Grid item>
                <StyledButton onClick={handleSortClick} type={"button"} color={"transparent"}>{t('searchBooksComponent.sort')}</StyledButton>
                <Menu
                    id="sort-menu"
                    anchorEl={sortAnchorEl}
                    keepMounted
                    open={Boolean(sortAnchorEl)}
                    onClose={handleSortClose}
                >
                    <StyledMenuContent>
                        <StyledRadioButton
                            options={[{label: t('searchBooksComponent.sortSubmittedDate'), value: 'submitted_date'}, {label: t('searchBooksComponent.sortMatching'), value: 'matching'}]}
                            value={sortFieldValue}
                            onChange={sortFieldChanged}
                        />
                        <hr/>
                        <StyledRadioButton
                            options={[{label: t('searchBooksComponent.desc'), value: 'desc'}, {label: t('searchBooksComponent.asc'), value: 'asc'}]}
                            value={sortValue}
                            onChange={sortChanged}
                        />
                    </StyledMenuContent>
                </Menu>
            </Grid>
            }
        </Grid>
    );
}

export interface Props {
    loadManuscripts: (sortFieldTmp, sortValueTmp, searchValueTmp) => {},
    showSort?: boolean
}

const StyledMenuContent = styled('div')`
  padding: 0 1rem;
`;
